module.exports = __webpack_public_path__ + "media/images/sp/hokepon_reserve/content-5113366c947d104cbae5c0f8f0a3b1e9.png";